import * as yup from "yup";

import { Button, Col, Form, Input, Layout, PageHeader, Row } from "antd";
import { Field, Formik } from "formik";
import { LockOutlined, UserOutlined } from "@ant-design/icons";
import { StyledHeader, StyledInternalContent } from "components/InternalLayout";

import React from "react";
import { connect } from "react-redux";
import { resetPassword } from "redux/user/actions";

const ResetPasswordPage: React.FC = ({ resetPassword }: any) => {
	const loginSchemaA = yup.object({
		newPassword: yup.string().required(),
		confirmNewPassword: yup
			.string()
			.oneOf([yup.ref("newPassword"), undefined], "Passwords must match"),
	});

	return (
		<Layout>
			<StyledHeader>
				<br />
				<PageHeader
					title={"Reset Password"}
					style={{ paddingBottom: 0 }}
				></PageHeader>
				<br />
			</StyledHeader>
			<StyledInternalContent>
				<Row justify="center" align="middle" style={{ height: "100vh" }}>
					<Col xs={20} md={8}>
						<Row>
							<Formik
								initialValues={{ newPassword: "", confirmNewPassword: "" }}
								onSubmit={async (data) => {
									resetPassword(data);
								}}
								validateOnChange={false}
								validateOnBlur={false}
								validationSchema={loginSchemaA}
							>
								{({ isSubmitting, errors, handleSubmit }) => (
									<Form
										onFinish={handleSubmit}
										style={{
											maxWidth: "100%",
											textAlign: "center",
										}}
									>
										{/*props.errorMessage !== "" && (
										<Alert message={props.errorMessage} type="error" />
									)*/}
										<Form.Item
											label={"New Password"}
											validateStatus={errors.newPassword ? "error" : "success"}
											help={errors.newPassword}
										>
											<Field
												name="newPassword"
												type="password"
												as={Input}
												prefix={
													<LockOutlined style={{ color: "rgba(0,0,0,.25)" }} />
												}
											/>
										</Form.Item>
										<Form.Item
											label={"Confirm New Password"}
											validateStatus={
												errors.confirmNewPassword ? "error" : "success"
											}
											help={errors.confirmNewPassword}
										>
											<Field
												name="confirmNewPassword"
												type="password"
												as={Input}
												prefix={
													<LockOutlined style={{ color: "rgba(0,0,0,.25)" }} />
												}
											/>
										</Form.Item>
										<Form.Item>
											<Button
												htmlType="submit"
												className="login-form-button"
												disabled={isSubmitting}
												size="large"
												style={{ width: "100%" }}
												shape="round"
											>
												{"Login"}
											</Button>
										</Form.Item>
									</Form>
								)}
							</Formik>
						</Row>
					</Col>
				</Row>
			</StyledInternalContent>
		</Layout>
	);
};

const mapStateToProps = (state: any) => {};

export default connect(mapStateToProps, { resetPassword })(ResetPasswordPage);
